import Vue from "vue";

let eventBus = new Vue();

let plugin = {
  install(Vue, options = {}) {
    Vue.prototype.$modal = {
      show(name, state) {
        eventBus.$emit("toggle", name, state);
      }
    }
  }
}

export { eventBus as ModalEventBus, plugin as ModalPlugin };